/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeclineMicroAuthCheckRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/MicroAuthVerification.pb'
import {DeclineMicroAuthCheckResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/MicroAuthVerification.pb'


export const declineMicroAuthCheck = (request: DeclineMicroAuthCheckRequest, options?: CashRequestOptions) => post<DeclineMicroAuthCheckRequest, DeclineMicroAuthCheckResponse>("/2.0/cash/decline-micro-auth-check", request, {...options, rejectOnError: true })